export enum Permissions {
    ViewAccountCreateContractFields = 'VIEW_ACCOUNT_CREATE_CONTRACT_FIELDS',
    ViewAdminSection = 'VIEW_ADMIN_SECTION',
    ViewAdminFullMenu = 'VIEW_ADMIN_FULL_MENU',
    ViewAdminEditUser = 'VIEW_ADMIN_EDIT_USER',
    ViewAdminReports = 'VIEW_ADMIN_REPORTS',
    ViewAdminBonusForm = 'VIEW_ADMIN_BONUS_FORM',
    ViewAdminInvoiceDetailPage = 'VIEW_ADMIN_INVOICE_DETAIL_PAGE',
    ViewPersonalAreaSection = 'VIEW_PERSONAL_AREA_SECTION',
    UserNotAuthorized = 'USER_NOT_AUTHORIZED',
    PermissionDenied = 'PERMISSION_DENIED',
    ViewModeration = 'VIEW_MODERATION',
}
